/** Built-in document templates — merged into org catalog when missing. */
export const SEED_DOC_TEMPLATES = {
  dsc_creation: {
    id: 'dsc_creation',
    name: 'DSC Creation',
    collectionType: 'director',
    infoFields: [
      { id: 'if1', label: 'Full Name (as per PAN)', type: 'text', required: true },
      { id: 'if2', label: "Father's Name", type: 'text', required: true },
      { id: 'if3', label: 'Date of Birth', type: 'date', required: true },
      { id: 'if4', label: 'Gender', type: 'select', required: true, options: ['Male', 'Female', 'Other'] },
      { id: 'if5', label: 'PAN Number', type: 'text', required: true },
      { id: 'if6', label: 'Mobile Number', type: 'tel', required: true },
      { id: 'if7', label: 'Email Address', type: 'email', required: true },
      { id: 'if8', label: 'Residential Address', type: 'textarea', required: true },
      { id: 'if9', label: 'Pincode', type: 'number', required: true },
    ],
    docSlots: [
      { id: 'ds1', label: 'PAN Card', required: true },
      { id: 'ds2', label: 'Aadhaar Card (Front Side)', required: true },
      { id: 'ds3', label: 'Aadhaar Card (Back Side)', required: true },
      { id: 'ds4', label: 'Passport Size Photo', required: true },
      { id: 'ds5', label: 'Specimen Signature', required: true },
      { id: 'ds6', label: 'Address Proof (Utility Bill / Rent Agreement)', required: true },
    ],
  },
  director_kyc: {
    id: 'director_kyc',
    name: 'Director KYC (DIR-3)',
    collectionType: 'director',
    infoFields: [
      { id: 'if1', label: 'Director Name (as per DIN)', type: 'text', required: true },
      { id: 'if2', label: 'DIN', type: 'text', required: true },
      { id: 'if3', label: 'PAN Number', type: 'text', required: true },
      { id: 'if4', label: 'Mobile Number', type: 'tel', required: true },
      { id: 'if5', label: 'Email Address', type: 'email', required: true },
    ],
    docSlots: [
      { id: 'ds1', label: 'PAN Card', required: true },
      { id: 'ds2', label: 'Aadhaar Card', required: true },
      { id: 'ds3', label: 'Passport Size Photo', required: true },
    ],
  },
  gst_return: {
    id: 'gst_return',
    name: 'GST Return Filing',
    collectionType: 'common',
    infoFields: [
      { id: 'if1', label: 'GSTIN', type: 'text', required: true },
      { id: 'if2', label: 'Return Period (e.g. Apr 2026)', type: 'text', required: true },
    ],
    docSlots: [
      { id: 'ds1', label: 'GSTR-1 Filed Acknowledgement / JSON', required: true },
      { id: 'ds2', label: 'GSTR-3B Filed Acknowledgement', required: true },
      { id: 'ds3', label: 'Challan / Payment Proof (if applicable)', required: false },
    ],
  },
  form_8_llp: {
    id: 'form_8_llp',
    name: 'Form 8 — LLP Statement of Accounts',
    collectionType: 'common',
    infoFields: [
      { id: 'if1', label: 'Financial Year', type: 'select', required: true, options: ['2024-25', '2025-26', '2026-27'] },
      { id: 'if2', label: 'Total Revenue (₹)', type: 'number', required: true },
      { id: 'if3', label: 'Total Expenses (₹)', type: 'number', required: true },
      { id: 'if4', label: 'Net Profit/Loss (₹)', type: 'number', required: true },
    ],
    docSlots: [
      { id: 'ds1', label: 'Audited Financials / P&L Statement', required: true },
      { id: 'ds2', label: 'Balance Sheet', required: true },
    ],
  },
  roc_annual: {
    id: 'roc_annual',
    name: 'ROC Annual Filing',
    collectionType: 'common',
    infoFields: [
      { id: 'if1', label: 'Financial Year', type: 'text', required: true },
      { id: 'if2', label: 'CIN', type: 'text', required: true },
    ],
    docSlots: [
      { id: 'ds1', label: 'Signed Financial Statements', required: true },
      { id: 'ds2', label: 'Board Report / Directors Report', required: true },
      { id: 'ds3', label: 'Auditor Report (if applicable)', required: false },
    ],
  },
  tds_return: {
    id: 'tds_return',
    name: 'TDS Return Filing',
    collectionType: 'common',
    infoFields: [
      { id: 'if1', label: 'TAN', type: 'text', required: true },
      { id: 'if2', label: 'Quarter (e.g. Q1 FY 2026-27)', type: 'text', required: true },
    ],
    docSlots: [
      { id: 'ds1', label: 'TDS Return Acknowledgement', required: true },
      { id: 'ds2', label: 'Challan Receipts', required: true },
    ],
  },
};

const SEED_BY_NAME = Object.fromEntries(
  Object.values(SEED_DOC_TEMPLATES).map((t) => [String(t.name).trim().toLowerCase(), t]),
);

/** Fill missing / stub catalog entries from built-in seed (keeps catalog id for task linkage). */
export function backfillFromSeed(existing, seed) {
  if (!seed) return existing || null;
  if (!existing) return { ...seed };
  const useSeedSlots = !existing.docSlots?.length
    || (existing.name && SEED_BY_NAME[String(existing.name).trim().toLowerCase()] === seed
      && existing.docSlots.length < seed.docSlots.length);
  const useSeedFields = !existing.infoFields?.length
    || (existing.name && SEED_BY_NAME[String(existing.name).trim().toLowerCase()] === seed
      && existing.infoFields.length < seed.infoFields.length);
  return {
    ...seed,
    ...existing,
    id: existing.id || seed.id,
    docSlots: useSeedSlots ? seed.docSlots : existing.docSlots,
    infoFields: useSeedFields ? seed.infoFields : existing.infoFields,
    collectionType: existing.collectionType || seed.collectionType,
    name: existing.name || seed.name,
  };
}

export function mergeSeedDocTemplates(catalog = {}) {
  const out = { ...catalog };
  for (const [id, seed] of Object.entries(SEED_DOC_TEMPLATES)) {
    out[id] = backfillFromSeed(out[id], seed);
  }
  return out;
}

export function resolveDocTemplate(templateId, catalog = {}) {
  if (!templateId) return null;
  const fromCatalog = catalog[templateId];
  const seed = SEED_DOC_TEMPLATES[templateId]
    || (fromCatalog?.name && SEED_BY_NAME[String(fromCatalog.name).trim().toLowerCase()])
    || null;
  if (seed) return backfillFromSeed(fromCatalog, seed);
  return fromCatalog || null;
}

if (typeof process !== 'undefined' && process.env?.NODE_ENV === 'test') {
  console.assert(resolveDocTemplate('dsc_creation', {}).docSlots.length === 6);
  const prodStub = {
    id: 'c0332fb1-7e39-4bb6-a9cc-1471474987be',
    name: 'DSC Creation',
    collectionType: 'director',
    infoFields: [{ id: 'a', label: 'Name', type: 'text', required: true }],
    docSlots: [{ id: 'b', label: 'PAN', required: true }],
  };
  console.assert(resolveDocTemplate(prodStub.id, { [prodStub.id]: prodStub }).docSlots.length === 6);
}
